import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-span-2 md:col-span-1" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Edit Loan Details ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DescriptionList = _resolveComponent("DescriptionList")!
  const _component_IconPencil = _resolveComponent("IconPencil")!
  const _component_SecondaryButton = _resolveComponent("SecondaryButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DescriptionList, {
      label: "Loan Amount",
      class: "col-span-2 md:col-span-1"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.loanAmount), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_DescriptionList, { label: "Margin" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.margin) + "% ", 1)
      ]),
      _: 1
    }),
    _createVNode(_component_DescriptionList, { label: "Base Interest Rate" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.baseInterestRate) + "% ", 1)
      ]),
      _: 1
    }),
    _createVNode(_component_DescriptionList, {
      label: "Start Date",
      size: "md"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.startDate), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_DescriptionList, {
      label: "End Date",
      size: "md"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.endDate), 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_SecondaryButton, {
        class: "mx-auto md:mx-0 justify-center",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('editLoan')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_IconPencil, { class: "h-6 w-6" }),
          _hoisted_2
        ]),
        _: 1
      })
    ])
  ], 64))
}